import script from "./RequestDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./RequestDetailsPage.vue?vue&type=style&index=0&id=0c272920&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c272920"]])

export default __exports__